import type React from "react"

export const ChevronUp: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  _props,
) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <title>Chevron Up</title>
    <path d="M15.41 302.7l191.1-183.1C212 114.2 218 111.1 224 111.1s11.97 2.219 16.59 6.688l191.1 183.1c9.594 9.152 9.906 24.34 .7187 33.9c-9.125 9.625-24.38 9.938-33.91 .7187L224 169.2l-175.4 168c-9.5 9.219-24.78 8.906-33.91-.7187C5.502 327 5.814 311.8 15.41 302.7z" />
  </svg>
)
